"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalValueResolver = exports.ValueResolver = void 0;
const RESOLVER = Symbol('resolver');
const VALUE = Symbol('value');
class ValueResolver {
    constructor(resolver) {
        this[RESOLVER] = resolver;
    }
    get(instance) {
        return this[RESOLVER](instance);
    }
}
exports.ValueResolver = ValueResolver;
class FinalValueResolver extends ValueResolver {
    get(instance) {
        if (this[VALUE] === undefined) {
            this[VALUE] = super.get(instance);
        }
        return this[VALUE];
    }
}
exports.FinalValueResolver = FinalValueResolver;
//# sourceMappingURL=ValueResolver.js.map